/* eslint-disable jsx-a11y/anchor-is-valid */
import classNames from "classnames";
import styles from "./Rodape.module.scss";
import logo from "assets/img/logo.png";
import logoDark from "assets/img/logo-dark.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faPhone,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  faWhatsapp,
  faLinkedin,
  faInstagram,
  faFacebook,
} from "@fortawesome/free-brands-svg-icons";
import { useTheme } from "contexts/ThemeProvider";

export default function Rodape() {
  const { theme, toggleTheme } = useTheme(); // 👈 hook para tema
  return (
    <footer className={styles.rodape}>
      <div className={styles.rodape__info}>
        <div
          className={classNames(
            styles.rodape__campo,
            styles["rodape__campo--logo"]
          )}
        >
          <a href="/" className={styles.rodape__logoLink}>
            <img
              src={logo ? (theme === "dark" ? logoDark : logo) : ""}
              alt="Logo Alcance Tecnologia"
              className={styles.rodape__logo}
            />
          </a>
          <p className={styles.rodape__ap}>
            Adoramos trabalhar com pessoas ambiciosas. Vamos construir algo
            incrível juntos.
          </p>
          <div className={styles.rodape__social}>
            <a
              href="https://www.linkedin.com/company/alcance-tecnologia/"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
              className={styles.rodape__socialLink}
            >
              <FontAwesomeIcon icon={faLinkedin} />
            </a>
            <a
              href="#"
              aria-label="Instagram"
              className={styles.rodape__socialLink}
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a
              href="https://www.facebook.com/alcancetecnologia"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
              className={styles.rodape__socialLink}
            >
              <FontAwesomeIcon icon={faFacebook} />
            </a>
            <a
              href="https://wa.me/554936211469"
              target="_blank"
              rel="noreferrer"
              aria-label="WhatsApp"
              className={styles.rodape__socialLink}
            >
              <FontAwesomeIcon icon={faWhatsapp} />
            </a>
          </div>
        </div>

        <div className={styles.rodape__campo}>
          <h3 className={styles.rodape__subtitulo}>Navegação</h3>
          <ul className={styles.rodape__lista}>
            <li className={styles.rodape__listaItem}>
              <a className={styles.rodape__link} href="/">
                Início
              </a>
            </li>
            <li className={styles.rodape__listaItem}>
              <a className={styles.rodape__link} href="/servicos">
                Serviços
              </a>
            </li>
            <li className={styles.rodape__listaItem}>
              <a className={styles.rodape__link} href="/empresa">
                Empresa
              </a>
            </li>
            <li className={styles.rodape__listaItem}>
              <a className={styles.rodape__link} href="/casosdesucesso">
                Casos de sucesso
              </a>
            </li>
          </ul>
        </div>

        <div className={styles.rodape__campo}>
          <h3 className={styles.rodape__subtitulo}>Empresa</h3>
          <ul className={styles.rodape__lista}>
            <li className={styles.rodape__listaItem}>
              <a className={styles.rodape__link} href="/empresa">
                Sobre
              </a>
            </li>
            <li className={styles.rodape__listaItem}>
              <a className={styles.rodape__link} href="/contato">
                Contato
              </a>
            </li>
            <li className={styles.rodape__listaItem}>
              <a className={styles.rodape__link} href="/blog">
                Blog
              </a>
            </li>
            <li className={styles.rodape__listaItem}>
              <a className={styles.rodape__link} href="/trabalheconosco">
                Trabalhe Conosco
              </a>
            </li>
          </ul>
        </div>

        <div className={styles.rodape__campo}>
          <h3 className={styles.rodape__subtitulo}>Contate-nos</h3>
          <ul className={styles.rodape__lista}>
            <li className={styles.rodape__listaItem}>
              <a
                className={styles.rodape__link}
                href="mailto:alcance@alcancetecnologia.com.br"
              >
                <FontAwesomeIcon
                  icon={faEnvelope}
                  className={styles.rodape__icon}
                />
                alcance@alcancetecnologia.com.br
              </a>
            </li>
            <li className={styles.rodape__listaItem}>
              <a
                className={styles.rodape__link}
                href="https://wa.me/554936211469"
              >
                <FontAwesomeIcon
                  icon={faPhone}
                  className={styles.rodape__icon}
                />
                +55 (049) 3621 1469
              </a>
            </li>
            <li className={styles.rodape__listaItem}>
              <a
                className={styles.rodape__link}
                href="https://maps.app.goo.gl/uEaazjUDcL6cVDpGA"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon
                  icon={faMapMarkerAlt}
                  className={styles.rodape__icon}
                />
                São Miguel do Oeste, SC
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.copyright}>
        <div className={styles.copyright__content}>
          <p>
            &copy; {new Date().getFullYear()} Alcance Tecnologia - Todos os
            direitos reservados
          </p>
          <div className={styles.copyright__links}>
            <a href="/politica-de-privacidade">Política de Privacidade</a>
            <a href="/termos-de-uso">Termos de Uso</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
